<template>
  <v-dialog v-model="dialog" width="550" scrollable>
    <v-card v-if="dialog">
      <v-card-title>
        <span v-if="loading">Aguarde...</span>
        <div v-else>
          Fatura {{fatura.numero}} - CANCELADA
          <br />
          <span class="subtitle-1">Cliente: {{ordem.cliente.id}} - {{ordem.cliente.nome}}</span>
        </div>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn color="primary" depressed @click="visualizar()" :disabled="disabled">
          <v-icon class="mr-2">mdi-eye-outline</v-icon>VISUALIZAR
        </v-btn>
        <seletor-email
          tipo-entidade="clientes"
          :id-entidade="ordem.id_cliente"
          tipo-padrao="financeiro"
          @confirmar="enviarEmail($event)"
        >
          <v-btn color="secondary" depressed :disabled="disabled || enviandoEmail" class="ml-2">
            <v-icon class="mr-2">mdi-email-send-outline</v-icon>
            {{enviandoEmail ? 'ENVIANDO' : 'ENVIAR EMAIL'}}
          </v-btn>
        </seletor-email>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import number_format from "../../lib/number_format";
import SeletorEmail from "../contatos/SeletorEmail";
export default {
  components: { SeletorEmail },
  data() {
    return {
      loading: true,
      enviandoEmail: false,
      fatura: null,
      incluirFatura: true,
      boletosSelecionados: [],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.boleto.seletor.faturaAtiva !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("boleto/setFaturaAtivaSeletor", null);
        }
      },
    },
    disabled() {
      return false;
    },
    ...mapState({
      ordem: (state) => state.boleto.seletor.faturaAtiva,
    }),
  },
  methods: {
    async carregarFatura() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(
          "ordemMedicao/buscarFaturaPorOrdem",
          {
            CarregarContasReceber: true,
            filtros: { id_ordem: this.ordem.id },
          }
        );
        this.fatura = response.data[0];
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a fatura",
        });
      }
      this.loading = false;
    },
    vencimento(cr) {
      return moment(cr.data_vencimento).format("DD/MM/YYYY");
    },
    valor(cr) {
      return number_format(cr.valor_receber);
    },
    async gerarImpressoes() {
      const p = [];

      p.push(
        this.$store.dispatch("relatorio/gerarFatura", this.fatura.id_ordem)
      );

      try {
        const impressoes = await Promise.all(p);
        return Promise.resolve(impressoes);
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível recuperar os boletos",
        });
        return Promise.reject(err);
      }
    },
    visualizar() {
      this.gerarImpressoes().then((impressoes) => {
        for (let impressao of impressoes.reverse()) {
          const url = window.URL.createObjectURL(
            new Blob([impressao], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 3000);
          link.remove();
        }
      });
    },
    async enviarEmail(emails) {
      this.enviandoEmail = true;
      try {
        const impressoes = await this.gerarImpressoes();
        const payload = new FormData();

        const arquivo = new File([impressoes.shift()], `FATURA_${this.fatura.numero}.pdf`, {
          type: "application/pdf",
        });
        payload.append("arquivos", arquivo);

        payload.append("emails", emails.join(","));

        await this.$store.dispatch("email/boletos", {
          id_fatura: this.fatura.id,
          payload,
        });
        this.dialog = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success",
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente",
        });
      }
      this.enviandoEmail = false;
    },
  },
  watch: {
    dialog(val) {
      this.boletosSelecionados = [];
      if (!val) {
        return;
      }

      this.carregarFatura();
    },
  },
};
</script>